import { MOCK } from './mock';

export type AppConfig = {
  apiUrl: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
};

/**
 * 接続先はデプロイ時に生成される /config.json から読む (ビルド成果物は環境非依存)。
 * ローカル開発では web/.env.local の VITE_* にフォールバックする。
 */
export async function loadConfig(): Promise<AppConfig> {
  if (MOCK) {
    return { apiUrl: '', region: 'mock', userPoolId: 'mock', userPoolClientId: 'mock' };
  }

  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const json = (await res.json()) as Partial<AppConfig>;
      if (json.apiUrl && json.userPoolId && json.userPoolClientId) {
        return { region: 'ap-northeast-1', ...json } as AppConfig;
      }
    }
  } catch {
    // config.json が無いローカル開発では env にフォールバック
  }

  const env = import.meta.env;
  const fallback: AppConfig = {
    apiUrl: env.VITE_API_URL ?? '',
    region: env.VITE_AWS_REGION ?? 'ap-northeast-1',
    userPoolId: env.VITE_USER_POOL_ID ?? '',
    userPoolClientId: env.VITE_USER_POOL_CLIENT_ID ?? '',
  };

  if (!fallback.apiUrl || !fallback.userPoolId || !fallback.userPoolClientId) {
    throw new Error(
      '接続設定が見つかりません。デプロイ後に出力される値を web/.env.local か public/config.json に設定してください。',
    );
  }
  return fallback;
}
